import { createCrudHooks } from './base'
import { trpc } from '../trpc'
import type {
  FeedbackWithRelations,
  CreateFeedback,
  UpdateFeedback,
  FeedbackTag,
} from '@markku/types'

// Feedback CRUD hooks
export const feedbackHooks = createCrudHooks<
  FeedbackWithRelations,
  FeedbackWithRelations,
  CreateFeedback,
  UpdateFeedback
>('feedback')

// Feedback tag hooks (for fetching available tags)
export const feedbackTagHooks = createCrudHooks<FeedbackTag>('feedbackTag')

// Export individual hooks for convenience
export const {
  useList: useFeedbackList,
  useGetById: useFeedbackGetById,
  useCreate: useFeedbackCreate,
  useUpdate: useFeedbackUpdate,
  useDelete: useFeedbackDelete,
} = feedbackHooks

export const { useList: useFeedbackTagList } = feedbackTagHooks

// CSAT aggregates for the company portal (read-only).
export const csatHooks = {
  useForCustomer: (customerId: number) =>
    trpc.feedback.csatForCustomer.useQuery({ customerId }),
  useForProperty: (propertyId: number) =>
    trpc.feedback.csatForProperty.useQuery({ propertyId }),
}
